export const KEY = 'edz1IInEZpnZubV09AMVZYN1746qxWQtvhMHZ72T';
export const testKey = '4SvVM56bU2CkTz2HELNAw4YepJmnE62NdC0aNr93';